import { render, staticRenderFns } from "./OpIsIcon.vue?vue&type=template&id=09769442&scoped=true"
import script from "./OpIsIcon.vue?vue&type=script&lang=js"
export * from "./OpIsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09769442",
  null
  
)

export default component.exports